window.initClientAccountForm = function() {
  $('[name="client_account[brand_access]"]').on('change', function(){
    if($(this).is(':checked')){
      $('.js-clients').addClass('is-hidden');
    } else {
      $('.js-clients').removeClass('is-hidden');
    }
  })
}